import template from './employee_upload_leave_document.html';
import tr from '../../lib/default-translator.js';

class EmployeeUploadLeaveDocumentViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.photofile = ko.observable();
		this.new_name = ko.observable('');
	};

	close()
	{
		this.dialog.close();
	}

	async uploadClick()
	{
		let formData = new FormData($('#batchuploadform')[0]);
		if (document.getElementById('batch_file').files[0])
		{
			if (document.getElementById('batch_file').files[0].size > 20000000)
			{
				Grape.alerts.alert({type: 'error', message: tr('File size exceeds the maximum limit of 20MB', 'File size exceeds the maximum limit of 20MB'), title: tr('Error', 'Error')});
				formData.append('abort_upload', 'true');
				return;
			}
		}

		/* this is for additional form data, if you need some more' */
		formData.append('employee_id', this.dialog.bindings.employee_id);
		formData.append('transaction_id', this.dialog.bindings.transaction_id);
		formData.append('name', this.new_name());

		if (this.new_name() == '')
		{
			Grape.alerts.alert({type: 'error', message: tr('Please supply a name for your document.'), title: tr('Error', 'Error')});
			return;
		}

		$('#upload_btn').button('loading');

		let xhr = new XMLHttpRequest();
		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4)
			{
				Grape.alerts.alert({type: 'success', message: tr('File uploaded successfully'), title: tr('Success', 'Success')});
				$('#upload_input').val('');
				$('#upload_btn').button('reset');

				this.dialog.close();
			}
		};
		xhr.open('post', '/employee/upload_leave_document', true);
		xhr.setRequestHeader('Accept', 'application/json');
		xhr.setRequestHeader('X-SessionID', localStorage.getItem('session_id'));
		xhr.send(formData);
	};
};

class EmployeeUploadLeaveDocumentPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeUploadLeaveDocumentViewModel(this);
		this.bindings = bindings;

		$('input[id=batch_file]').change((event) => {
			let file = event.target.files[0]
			if (file) {
				$('#upload_input').val(file.name)
				this.viewModel.has_attachment(true)
			} else {
				$('#upload_input').val('')
				this.viewModel.has_attachment(false)
			}
		})
	};
};

export default {
	name: 'EmployeeUploadLeaveDocument',
	dialog_class: EmployeeUploadLeaveDocumentPage,
	template: template,
	template_filename: 'translation/dialogs/employee_upload_leave_document',
	provider: 'ps'
};
